"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var BrandType_1 = require("../types/enums/BrandType");
var graph_ql_1 = require("../types/graph-ql");
var utils_1 = require("./utils");
var Slot_1 = require("./Slot");
var Title_1 = require("./Title");
exports.shouldDisplaySlotDetail = function (brand) {
    if (utils_1.isNilOrEmpty(brand.slots)) {
        return false;
    }
    return !Title_1.hasPlayableVod(brand);
};
exports.getSynopsis = function (brand) {
    var _a, _b;
    if (Title_1.isShow(brand)) {
        var slot = Title_1.getFirstAvailableSlot(brand);
        return brand.type === graph_ql_1.ShowType.Sport && ((_a = slot === null || slot === void 0 ? void 0 : slot.programme) === null || _a === void 0 ? void 0 : _a.synopsis)
            ? (_b = slot === null || slot === void 0 ? void 0 : slot.programme) === null || _b === void 0 ? void 0 : _b.synopsis : brand.synopsis;
    }
    return brand.synopsis;
};
exports.getImage = function (_brand, brandImage) {
    return brandImage;
};
// TODO we need to add entitlement check and button text into settings
exports.getPlayButtonSetting = function (brand, isPpv, isTvod) {
    var firstAvailableSlot = Title_1.getFirstAvailableSlot(brand);
    var isSlotLive = firstAvailableSlot && Slot_1.isSlotOnAir(firstAvailableSlot);
    // Vod has high priority than linearSlot
    if (Title_1.hasPlayableVod(brand) || isPpv || isTvod) {
        if (brand.__typename === BrandType_1.BrandType.Show) {
            return {
                visible: true,
                isVod: true,
                videoContent: brand.defaultEpisode,
            };
        }
        if (brand.__typename === BrandType_1.BrandType.Movie) {
            return { visible: true, isVod: true, videoContent: brand.asset };
        }
        if (brand.__typename === BrandType_1.BrandType.PayPerViewEvent) {
            return {
                visible: !utils_1.isNilOrEmpty(firstAvailableSlot),
                isVod: false,
                videoContent: firstAvailableSlot,
            };
        }
    }
    if (isSlotLive) {
        return {
            visible: true,
            isVod: false,
            videoContent: firstAvailableSlot,
        };
    }
    return {
        visible: false,
        isVod: false,
    };
};
// Display logic for record button.
exports.getRecordButtonSetting = function (brand) {
    var firstAvailableSlot = Title_1.getFirstAvailableSlot(brand);
    var playButtonSetting = exports.getPlayButtonSetting(brand);
    // hide it if the play button is displayed for vod
    if (firstAvailableSlot && !(playButtonSetting.visible && playButtonSetting.isVod)) {
        return {
            visible: true,
        };
    }
    return {
        visible: false,
    };
};
// TODO we need to add entitlement check and button text into settings
exports.getWatchlistButtonSetting = function () { return ({ visible: true }); };
//# sourceMappingURL=Hero.js.map